import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';

import { JssTreeObject } from '../../model/jss-tree-object';
import { JssNodeAbstract } from '../../model/jss-tree-abstract';

@Component({
   selector: 'app-mat-group',
   templateUrl: './group.component.html',
   styleUrls: ['./group.component.scss']
})
export class GroupComponent implements OnInit, OnChanges {

   // public to access in template directly
   public _children: JssNodeAbstract[] = null;
   public _nodeName: string = null;
   public _nodeType: string = null;
   public _title: string = null;
   public _formGroup: FormGroup | FormArray = null;

   @Input() jssTreeObject: JssTreeObject = null;
   @Input() readonly = false;

   constructor() { }

   ngOnInit() {
   }

   ngOnChanges() {
      if (this.jssTreeObject) {
         this._nodeName = this.jssTreeObject.nodeName;
         this._nodeType = this.jssTreeObject.nodeType;
         this._children = this.jssTreeObject.children;
         this._formGroup = this.jssTreeObject.formGroup;

         // title
         if (this.jssTreeObject.showTitle) {
            this._title = this.jssTreeObject.hasTitle() ? this.jssTreeObject.title : this._nodeName;
         }
      }
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/group/group.component.ts